// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3CEve","left":"StickyBox_left__3kezk","right":"StickyBox_right__2r4Uv"};